module.exports = __webpack_public_path__ + "static/img/yizhangtu_02.4acf022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yizhangtu_02.png
// module id = 5kjm
// module chunks = 1